// Module
var code = "<div ng-attr-id=\"{{$ctrl.flowModel.id}}\"></div> ";
// Exports
export default code;